import { useSyncExternalStore } from 'react';

// Owned here rather than in @jotpsych/statsig so Vite resolves the import and
// code-splits the package into a chunk only fetched when overrides are enabled.
export const loadLocalOverrides = () => import('@statsig/js-local-overrides');

const ALWAYS_ENABLED = Boolean(import.meta.env.DEV || import.meta.env.VITE_E2E_MODE);

let requested = false;
const listeners = new Set<() => void>();

/**
 * Enable local overrides for the rest of this page's life. For code that
 * needs them outside the dev server and E2E builds: the public sample-note
 * route pins its gates through them. The provider attaches the adapter to the
 * running client, so this works however the route was reached.
 */
export function requestLocalOverrides(): void {
  if (requested) {
    return;
  }
  requested = true;
  listeners.forEach(listener => listener());
}

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): boolean => ALWAYS_ENABLED || requested;

/** Whether the Statsig provider should load the local override adapter. */
export function useLocalOverridesEnabled(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
